import { APP_INITIALIZER, Provider } from '@angular/core';
import { DOMAIN_SUBSCRIBERS } from "../../../booking/domain/tokens/booking.tokens";
import { GetLastSimpleTicketSubscriber } from '../../application/subscribers/get-last-ticket.subscriber';
import { GetTicketOnAccountClosedSubscriber } from '../../application/subscribers/get-ticket-on-account-closed.subscriber';
import { TICKET_LISTENER, TICKET_REPOSITORY } from '../../domain/tokens/ticket.token';
import { TicketQueryRepositoryAdapter } from '../adapters/ticket-query-repository.adapter';
import { TicketUpdatedListener } from '../listeners/ticket-serie-updated.listener';

export const TICKET_PROVIDERS: Provider[] = [
  {
    provide: TICKET_REPOSITORY,
    useClass: TicketQueryRepositoryAdapter,
  },
  {
    provide: DOMAIN_SUBSCRIBERS,
    useClass: GetTicketOnAccountClosedSubscriber,
    multi: true
  },
  {
    provide: DOMAIN_SUBSCRIBERS,
    useClass: GetLastSimpleTicketSubscriber,
    multi: true
  },
  {
    provide: TICKET_LISTENER,
    useClass: TicketUpdatedListener,
  },
  {
    provide: APP_INITIALIZER,
    deps: [DOMAIN_SUBSCRIBERS, TICKET_LISTENER],
    useFactory: () => () => {
    },
    multi: true,
  },
];
